export default "__VITE_ASSET__Bwoj59W9__"